import { Grid  } from "@mui/material";
import { 
    useCallback,
    useEffect,
    useState 
} from "react";

import {
    Create,
    Datagrid,
    DeleteButton,
    Edit,
    List,
    Pagination,
    SimpleForm,
    SaveButton,
    TextField,
    TextInput,
    Toolbar,
    useCreate,
    ArrayInput, 
    SimpleFormIterator, 
    ReferenceInput, 
    SelectInput, 
    NumberInput,
    ArrayField, SingleFieldList, ChipField,
    useDataProvider,
    useRecordContext,
    EditButton
}
from "react-admin";

const JourneyListFilters = [
    <TextInput label="Jouney Name" source="name__icontains" alwaysOn />,
    <SelectInput source="status" label="Status" choices={[
        {id: "active", name: "Active"},
        {id: "inactive", name: "Inactive"},
        {id: "deleted", name: "Deleted"},
    ]} fullWidth />
];

const MyPagination = () => <Pagination rowsPerPageOptions={[10,20,30]} />;

export const JourneyList = () => (
    <List filters={JourneyListFilters} pagination={<MyPagination/>}>
        <Datagrid>
            <TextField label="name" source="name"/>
            <ArrayField source="challenges">
                <SingleFieldList>
                    <ChipField source="challenge.name" />
                </SingleFieldList>
            </ArrayField>
            <TextField label="status" source="status"/>
            <TextField label="description" source="description"/>
            <TextField label="brush type" source="brushType"/>
            <TextField label="geoffrey goal" source="geoffreyGoal"/>
            <EditButton/>
        </Datagrid>
    </List>
);


const validateJourneyCreation = (values: any) => {
    const errors: any = {};
    if (!values.name){
        errors.name = "Name is required";
    }
    return errors;
};

const JourneyCreateEditForm = () => {
    const dataProvider = useDataProvider() as any;
    const [statusChoices, setStatusChoices] = useState<{ id: string; name: string }[]>([]);

    useEffect(() => {
        let mounted = true;
        dataProvider
            .getJourneyStatusOptions()
            .then((res: any) => {
                if (mounted) setStatusChoices(res.data || []);
            })
            .catch(() => {
                if (mounted) setStatusChoices([]);
            });

        return () => {
            mounted = false;
        };
    }, [dataProvider]);

    return (
      <Grid container columnSpacing={2}>
        <Grid item xs={0} sm={2}></Grid>
        <Grid item xs={12} sm={8}>
            <TextInput source="name" label="Name" fullWidth />
            <ArrayInput source="challenges" label="Challenges">
                <SimpleFormIterator>
                    <ReferenceInput
                    label="Challenge"
                    source="challengeId"
                    reference="challenge"
                    fullWidth
                    >
                    <SelectInput optionText="name" />
                    </ReferenceInput>
                    <NumberInput source="order" label="Order" />
                    {/* Add more fields as needed, e.g.: */}
                    {/* <NumberInput source="coins" label="Coins" /> */}
                </SimpleFormIterator>
            </ArrayInput>
            <SelectInput source="status" label="Status" choices={statusChoices} fullWidth />
            <TextInput source="description" label="Description" fullWidth />
            <TextInput source="brushType" label="Brush Type" fullWidth />
            <TextInput source="geoffreyGoal" label="Geoffrey Goal" fullWidth />
        </Grid>
      </Grid>
    );
};


export const JourneyEdit = () => {
    return (
        <Edit>
            <SimpleForm validate={validateJourneyCreation}>
                <JourneyCreateEditForm />
            </SimpleForm>
        </Edit>
    )
}


export const JourneyCreate = () => {
    const [create] = useCreate();
    const save = useCallback(
        async (values: any) => {
            try {
                await create("journey", {data: values}, {returnPromise: true});
            } catch (error: any) {
                if (error!.body!.errors) {
                    return error.body.errors;
                }
            }
        },
        [create]
    );

    return (
        <Create>
            <SimpleForm validate={validateJourneyCreation}>
                <JourneyCreateEditForm />
            </SimpleForm>
        </Create>
    )
}

const MyToolbar = (props: any) => {
    const record = useRecordContext();

    return (
        <Toolbar {...props} sx={{ justifyContent: "space-between" }}>
            <SaveButton label="Update"/>
            <DeleteButton label="Delete" sx={{ textAlign: "right" }} />
        </Toolbar>
    )

}
